import { render, staticRenderFns } from "./ModalChangeEmail.vue?vue&type=template&id=3d6c86dc&scoped=true&"
import script from "./ModalChangeEmail.vue?vue&type=script&lang=js&"
export * from "./ModalChangeEmail.vue?vue&type=script&lang=js&"
import style0 from "./ModalChangeEmail.vue?vue&type=style&index=0&id=3d6c86dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6c86dc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
